var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"hotel-image",class:{'hotel-image--placeholder': !_vm.hotel.getMainImage()},style:({ backgroundImage: _vm.hotelMainImage(_vm.hotel.getMainImage()) }),on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }